import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCubes,
  faHourglassHalf,
  faScaleUnbalanced,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import StatisticsCard from "../uielements/StatisticsCard";
import Api from "../../helpers/apiHandler";
import countsActions from "../../redux/counts/actions";
import { newPermissionValue } from "../../helpers/constants";
import { prefetchRoutes } from "../../helpers/prefetchRoutes";

const { updateCount } = countsActions;
const api = new Api();

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    `repeat(${Math.max(props.$columns || 1, 1)}, minmax(0, 1fr))`};
  gap: 20px;
  @media only screen and (max-width: 1080px) {
    grid-template-columns: ${(props) =>
      props.$columns > 2
        ? "repeat(2, minmax(0, 1fr))"
        : `repeat(${Math.max(props.$columns || 1, 1)}, minmax(0, 1fr))`};
  }
  @media only screen and (max-width: 700px) {
    grid-template-columns: ${(props) =>
      props.$columns > 1
        ? "repeat(2, minmax(0, 1fr))"
        : `repeat(${Math.max(props.$columns || 1, 1)}, minmax(0, 1fr))`};
  }
  @media only screen and (max-width: 424px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const ProductionCounts = ({
  onUpdateCount,
  counts,
  companyId,
  sideBarItems,
  ...props
}) => {
  const [count, setCount] = useState({});
  const [isRecipe, setIsRecipe] = useState(false);
  const [isAssemblies, setIsAssemblies] = useState(false);
  const [isProduction, setIsProduction] = useState(false);

  useEffect(() => {
    let recipeAccess = false;
    let assembliesAccess = false;
    let productionAccess = false;

    if (sideBarItems && sideBarItems.length > 0) {
      sideBarItems.forEach((item) => {
        const moduleName = (item.moduleName || "").toLowerCase().trim();
        const hasAccess = item.permissionId != newPermissionValue.noAccess;

        if (moduleName === "recipe") {
          recipeAccess = hasAccess;
        }
        if (moduleName === "assemblies" || moduleName === "assembly") {
          assembliesAccess = hasAccess;
        }
        if (
          item.moduleName === "Production Run" ||
          moduleName === "production run" ||
          moduleName === "production"
        ) {
          productionAccess = hasAccess;
        }
      });
    }

    setIsRecipe(recipeAccess);
    setIsAssemblies(assembliesAccess);
    setIsProduction(productionAccess);
  }, [sideBarItems]);

  useEffect(() => {
    const paths = [];
    if (isRecipe) paths.push("recipe");
    if (isProduction) paths.push("production");
    if (isAssemblies) paths.push("assemblies");
    prefetchRoutes(paths);
  }, [isRecipe, isProduction, isAssemblies]);

  useEffect(() => {
    if (companyId) {
      getCount();
    }
  }, [companyId]);

  useEffect(() => {
    if (counts) {
      setCount(counts);
    }
  }, [counts]);

  const getCount = () => {
    if (!companyId) return;

    const payload = {
      companyId: companyId,
      menuType: "PRODUCTION",
    };

    api
      .post("common/count", {
        isMultipart: false,
        data: payload,
      })
      .then((response) => {
        if (response.status === 1) {
          onUpdateCount({
            production: {
              recipes: response.data.recipe || 0,
              assemblies:
                response.data.assembly || response.data.assemblies || 0,
              currentProjects: response.data.currentProject || 0,
              upcomingProjects: response.data.upComingProject || 0,
            },
          });
        }
      })
      .catch((error) => {
        console.log("Error fetching counts:", error);
      });
  };

  const redirectRoute = (routname) => {
    if (props.location.pathname !== routname) {
      props.history.push(routname);
    }
  };

  const visibleColumns = [isRecipe, isProduction, isProduction, isAssemblies].filter(
    Boolean
  ).length;

  return (
    <GridContainer className="width-100" $columns={visibleColumns || 1}>
      {isRecipe && (
        <StatisticsCard
          title={"Recipes"}
          count={count.recipes || 0}
          icon={
            <FontAwesomeIcon
              icon={faUtensils}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#9D6AB0"}
          to="/recipe"
          onClick={() => redirectRoute("/recipe")}
        />
      )}
      {isProduction && (
        <StatisticsCard
          title={"Production Runs"}
          count={count.upcomingProjects || 0}
          icon={
            <FontAwesomeIcon
              icon={faCalendarAlt}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#EE5A92"}
          to="/production"
          onClick={() => props.history.push("/production")}
        />
      )}
      {isProduction && (
        <StatisticsCard
          title={"Current Production Runs"}
          count={count.currentProjects || 0}
          icon={
            <FontAwesomeIcon
              icon={faHourglassHalf}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#20CCE2"}
          to="/production"
          onClick={() => redirectRoute("/production?status=start")}
        />
      )}
      {isAssemblies && (
        <StatisticsCard
          title={"Assemblies"}
          count={count.assemblies || 0}
          icon={
            <FontAwesomeIcon
              icon={faCubes}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#348EE2"}
          to="/assemblies"
          onClick={() => redirectRoute("/assemblies")}
        />
      )}
      {/* <StatisticsCard
        title={
          <span>
            Weights and
            <br /> Measures
          </span>
        }
        icon={
          <FontAwesomeIcon
            icon={faScaleUnbalanced}
            style={{
              height: "16px",
              width: "16px",
              color: "#fff",
            }}
          />
        }
        color={"#348EE2"}
        showOnlyTitle
      /> */}
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  companyId: state.Auth.company.id,
  counts: state.Counts.production,
  sideBarItems: state.Auth.sideBarItems,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateCount: (data) => dispatch(updateCount(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductionCounts)
);
